export default __webpack_public_path__ + "static/benefitImg-b2cc1ec3e3306f3f793308cc79847599.png";